import { useMap, LayersControl, LayerGroup, TileLayer } from "react-leaflet"
import { ensurePane } from "@/utils/mapUx"

const SEAMARK_PANE = "seamark-overlay"

// Die Basiskarte kommt aus benchmap; hier bleibt nur das OpenSeaMap-Overlay.
export default function MapBaseLayers() {
  const map = useMap()

  // Idempotent, direkt im Render: Pane muss vor dem TileLayer existieren
  // (über benchmaps Wetter-Pane 450, unter den Routen-Panes 600+)
  ensurePane(map, SEAMARK_PANE, 470)

  return (
    <LayersControl position="bottomright">
      <LayersControl.Overlay name="OpenSeaMap">
        <LayerGroup id="layergroup_openseamap">
          <TileLayer
            url="https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png"
            pane={SEAMARK_PANE}
          />
        </LayerGroup>
      </LayersControl.Overlay>
    </LayersControl>
  )
}
